/**
 * 西班牙语（es）
 */
export default {
  commodity: {
    Components: {
      Select: {
        SearchFor: 'Buscar'
      },
      Search: {
        UploadAPicture: 'sube una foto'
      },
      Sale: {
        AutumnWinter: 'Otoño invierno',
        SpringSummer: 'Primavera verano',
        FourSeasons: 'Cuatro estaciones',
        Festival: 'Festival'
      },
      ReturnRefund: {
        Tips1: 'Para crear un excelente entorno comercial y mejorar los servicios de KakaClo, KakaClo emite la política general para el comportamiento de devolución y reembolso. Esta Política se aplica a todos los usuarios de KakaClo.',
        Accept: 'Aceptar',
        Tips2: 'KakaClo se reserva el derecho de actualizar las reglas cuando sea necesario, y la versión actualizada se publicará en KakaClo con efecto inmediato. Si se niega a aceptar la política, se considera que ha renunciado al uso de los servicios proporcionados por KakaClo de inmediato. Se considera que todos los compradores o proveedores aceptan las reglas si utilizan los servicios proporcionados por KakaClo.',
        Tips3: 'Para problemas posteriores a la venta, los compradores deben presentar una solicitud de devolución y reembolso dentro de los 30 días posteriores al día de entrega.',
        Tips4: 'Una vez que el comprador envía la solicitud de posventa, debe proporcionar pruebas (como se indica en la cláusula a continuación) a KakaClo. Si el comprador no puede proporcionar pruebas convincentes a tiempo, KakaClo tiene derecho a rechazar el reembolso o devolver la solicitud.',
        Tips5: 'Todos los artículos deben devolverse en buenas condiciones con la caja/embalaje original, incluidas las etiquetas del fabricante, las piezas y los accesorios.',
        Tips6: 'KakaClo determinará en última instancia si la evidencia es convincente o no.',
        Tips7: 'Bajo Varias Circunstancias:',
        Tips8: '1. No enviado después del tiempo de procesamiento',
        Tips9: 'El comprador tiene derecho a solicitar un reembolso completo por el pedido que no se envió más allá del tiempo de procesamiento (sujeto al tiempo de procesamiento estimado que se muestra en la página del pedido).',
        Tips10: '2. Información de recibo incorrecta',
        Tips11: 'Si el comprador completa la información de recepción incorrectamente, comuníquese con el servicio al cliente o el personal de atraque a tiempo para confirmar si se enviaron los productos.',
        Tips12: 'Si no hay entrega, el comprador puede actualizar la dirección de entrega con la información correcta.',
        Tips13: 'Si los productos han sido enviados, el comprador debe comunicarse con la empresa de logística para volver a entregarlos.',
        Tips14: 'Si se aprueba la solicitud de reembolso, el comprador debe devolver el producto a su cargo y cargar la información de seguimiento de devolución de manera oportuna. Después de que KakaClo reciba los productos devueltos sin ningún daño, se deducirá parte del monto del pedido como costo de reempaquetado y reabastecimiento.',
        Tips15: 'Si la mercancía no puede ser redistribuida o devuelta, el comprador correrá con las pérdidas correspondientes.',
        Tips16: 'Nota: En este caso, KakaClo tiene derecho a rechazar la solicitud de reembolso.',
        Tips17: '3. Productos no defectuosos',
        Tips18: 'Si el comprador solicita una devolución y un reembolso por productos no defectuosos, debe devolver el producto a su cargo y cargar la información de seguimiento de la devolución a tiempo. Después de que KakaClo reciba los artículos devueltos sin ningún daño, se deducirá una parte del monto del pedido como tarifa de reempaque y reabastecimiento. Nota: KakaClo tiene derecho a rechazar la solicitud de reembolso en esta circunstancia.',
        Tips19: '4. Productos defectuosos (rotura del paquete/muy diferente a la descripción/mercancías faltantes o incorrectas/problemas de calidad)',
        Tips20: 'Si el comprador detecta algún problema al recibirlo (paquete dañado/muy distinto al descrito/mercancías faltantes o incorrectas u otros problemas de calidad), deberá ponerse en contacto con el servicio de atención al cliente de KakaClo o manejar el receptor dentro de los 5 días hábiles a partir de la fecha de entrega. proporcione evidencia para probar el problema (imágenes de productos rotos y la caja exterior del paquete con una etiqueta de envío). KakaClo puede rechazar la solicitud de reembolso si el comprador no proporciona pruebas convincentes a tiempo.',
        Tips21: 'Para cualquier problema que surja en el proceso de uso del producto, los compradores deben comunicarse con KakaClo dentro de los 30 días a partir de la fecha de envío y proporcionar imágenes o videos relevantes como evidencia. Si el tiempo de respuesta es más de 30 días desde el tiempo de entrega, o si el comprador proporciona pruebas insuficientes, KakaClo puede rechazar la solicitud de reembolso si el comprador no proporciona pruebas convincentes a tiempo.',
        Tips22: 'Si KakaClo acepta reembolsar, el comprador deberá devolver los productos a tiempo y cargar el número de seguimiento. El KakaClo reembolsará en su totalidad al recibirlo.',
        Tips23: 'Si el comprador acepta volver a enviar, el comprador deberá devolver y cargar el número de seguimiento a tiempo. KakaClo reenviará el producto al recibirlo. Si ambas partes no logran llegar a un acuerdo, el comprador se comunicará con KakaClo y proporcionará las pruebas pertinentes (foto o video de los productos problemáticos). Una vez que se verifique la evidencia, KakaClo ayudará de manera proactiva al comprador a obtener el reembolso correspondiente.',
        Tips24: '5. Problemas de logística',
        Tips25: '5.1 Información de seguimiento no válida',
        Tips26: 'Si KakaClo verifica que el número de seguimiento es incorrecto, el comprador debe comunicarse con nosotros a tiempo. Verifique y vuelva a dar un número de seguimiento preciso',
        Tips27: '5.2 Actualizaciones inoportunas de la información de seguimiento',
        Tips28: 'Si no hay una actualización de la información de seguimiento durante más de 10 días hábiles (desde el momento en la información de seguimiento del sitio web de logística), los compradores deben ponerse en contacto con el servicio de atención al cliente de KakaClo o la persona de acoplamiento a tiempo para negociar una solución. Nota: esta cláusula no es aplicable para tiempos/períodos especiales como días festivos, covid-19, clima anormal u otras situaciones anormales.',
        Tips29: '5.3 Paquete no recibido',
        Tips30: 'Si el tiempo de tránsito supera el tiempo de entrega estimado en 10 días o más y el proveedor no proporciona un comprobante de entrega, los Compradores deben comunicarse con el servicio de atención al cliente de KakaClo o el personal de acoplamiento a tiempo.',
        Tips31: '6. Otros',
        Tips32: 'Cuando se encuentren con días festivos, covid-19, clima anormal u otras situaciones anormales, los Compradores deben comunicarse con el servicio al cliente de KakaClo o con el personal de atraque a tiempo para resolver los problemas de mercancías o logística.',
        Tips33: 'Para cualquier problema recibido, KakaClo emitirá un juicio basado en los hechos. El tiempo máximo de evaluación es de dos semanas después de la intervención de KakaClo.',
        Tips34: 'Para problemas de devolución, comuníquese primero con el servicio de atención al cliente correspondiente para que coincida con el almacén más cercano.',
        Tips35: '7. Contáctenos'
      },
      NewTime: {
        NewIn: 'Nuevo en'
      },
      CustomerReviews: {
        NoReviewsYet: 'Aún no hay reseñas.',
        Tips1: 'Sé el primero en escribir una reseña.',
        Color: 'Color',
        Size: 'Tamaño',
        ViewMore: 'ver más',
        Tips2: 'Vestido de mujer con espalda descubierta y volantes halter',
        SubmitReview: 'Enviar opinión',
        WriteAReview: 'Escribe una reseña',
        Select: 'seleccionar',
        Tips3: 'Escribe una breve reseña',
        YourName: 'Su nombre',
        YourEmailAddress: 'Su dirección de correo electrónico',
        Review: 'Revisar',
        Name: 'Nombre',
        Email: 'Correo electrónico'
      },
      AddingToBag: {
        AddingToBagSucceed: 'Agregar a la bolsa con éxito',
        Item: 'Artículo',
        Subtotal: 'Total parcial',
        ViewMyBag: 'Ver mi bolsa',
        ContinueShopping: 'Seguir comprando'
      }
    },
    ProductDetail: {
      ShipFrom: 'Nave de',
      ShopSimilar: 'Comprar similares',
      EndIn: 'terminar en',
      Over: 'encima',
      Sales: 'Ventas',
      Shipping: 'Envío',
      NoLogisticsChannel: 'Sin canal logístico',
      ShipTo: 'Envie a',
      Cost: 'Costo',
      Color: 'Color',
      PACK: 'PACK',
      QTY: 'QTY',
      AMT: 'AMT',
      ResetQty: 'Restablecer cantidad',
      SoldOut: 'Agotado',
      Sizing: 'Dimensionamiento',
      TrueToSize: 'Fiel al tamaño',
      MaterialComposition: 'Composición del material',
      SizeChart: 'Carta del tamaño',
      TableData: 'tabla de datos',
      InchData: 'pulgadas de datos',
      WeThinkYoullLoveThese: 'Creemos que te encantarán estos',
      China: 'China',
      CanSupportMostCountryConfigurations: 'Puede admitir la mayoría de las configuraciones de países',
      Germany: 'Alemania',
      OnlyLocalCountryConfigurationsAreSupported: 'Solo se admiten configuraciones de países locales.',
      ForExample: 'Por ejemplo',
      USProductsAreOnlySupportedForShippingToTheUS: 'Los productos de EE. UU. solo se admiten para envíos a EE. UU.',
      DeliveryTime: 'El tiempo de entrega',
      AllVariants: 'Todas las variantes',
      SelectAll: 'Seleccionar todo',
      Inventory: 'Inventario',
      AddToBag: 'Agregar a la bolsa',
      Total: 'Total',
      Pieces: 'piezas',
      tableData: 'datos de la tabla',
      inchData: 'inchData',
      SignIn: 'Inicia sesión para desbloquear el contenido completo',
      SignInSignUp: 'Iniciar sesión / Inscribirse'
    },
    PaymentStatus: {
      Payment: 'Pago',
      PaymentSuccessful: 'Pago exitoso',
      CheckOrder: 'Revisar orden',
      BackToShoppingBag: 'Volver a la cesta de la compra',
      Order: 'Orden',
      StoreOrderID: 'ID de pedido de la tienda',
      OrderID: 'Solicitar ID',
      Source: 'Fuente',
      ShopifyRtoiweuuyir: 'shopify rtoiweuuyir',
      PaymentTime: 'Tiempo de pago',
      PaymentAmount: 'Monto del pago',
      PaymentMethod: 'Método de pago',
      Balance: 'Balance',
      CreditCard: 'Tarjeta de crédito',
      Paypal: 'PayPal',
      Others: 'Otros',
      EverySingleProductGoesThroughOurRigorousQualityInspectionBeforeWeSendItToYourCustomers: 'Cada producto pasa por nuestra rigurosa inspección de calidad antes de enviarlo a sus clientes.',
      OrderCreation: 'Creación de pedidos',
      Shipped: 'Enviado',
      Complete: 'Completo',
      PaymentFail: 'Pago fallido',
      Home: 'Hogar',
      ViewOrder: 'Ver pedido',
      Back: 'Atrás'
    },
    InStock: {
      SeachFor: 'Buscar'
    },
    ConfirmOrder: {
      ContactInformation: 'Información del contacto',
      AlreadyHaveAnAccount: '¿Ya tienes una cuenta?',
      LogIn: 'Acceso',
      LoginSuccessful: 'Inicio de sesión exitoso',
      Shipping: 'Envío',
      PromotionalCodes: 'Códigos promocionales',
      Apply: 'Aplicar',
      DeductionForHighestProductPrice: 'Deducción por mayor precio del producto.',
      Creditcard: 'Tarjeta de crédito',
      Paypal: 'PayPal',
      Others: 'Otros',
      TipsOne: 'Aceptamos devolución de productos. Los clientes tienen derecho a solicitar una devolución dentro de los 14 días posteriores a la recepción del producto. Para ser elegible para una devolución, su artículo debe estar sin usar y en las mismas condiciones en que lo recibió. También debe estar en el embalaje original. Para completar su devolución, requerimos un recibo o comprobante de compra. Por favor, no devuelva su compra al fabricante.',
      TipsTwo: 'Para problemas posteriores a la venta, los compradores deben presentar una solicitud de devolución y reembolso dentro de los 30 días posteriores al día de entrega. Una vez que el comprador envía la solicitud de posventa, debe proporcionar pruebas (como se indica en la cláusula a continuación) al kakaclo. Si el comprador no puede proporcionar pruebas convincentes a tiempo, los kakaclo tienen derecho a rechazar el reembolso o devolver la solicitud.',
      TipsThree: 'Si el comprador completa la información de recepción incorrectamente, comuníquese con el servicio al cliente o el personal de atraque a tiempo para confirmar si se enviaron los productos. Si no hay entrega, el comprador puede actualizar la dirección de entrega con la información correcta. Si los productos han sido enviados, el comprador debe comunicarse con la empresa de logística para volver a entregarlos. Si se aprueba la solicitud de reembolso, el comprador debe devolver el producto a su cargo y cargar la información de seguimiento de devolución de manera oportuna. Después de que kakaclo reciba los productos devueltos sin ningún daño, se deducirá parte del monto del pedido como costo de reempaquetado y reabastecimiento. Si la mercancía no puede ser redistribuida o devuelta, el comprador correrá con las pérdidas correspondientes.',
      AddANewAddress: 'Añadir una nueva dirección',
      ShipMethod: 'Método de envío',
      AnotherMethod: 'Otro método',
      DeliveryTime: 'El tiempo de entrega',
      Cost: 'Costo',
      ShippingCost: 'Costo de envío',
      CustomizedService: 'Servicio Personalizado',
      PaymentMethod: 'Método de pago',
      OrderAmount: 'Total de la orden',
      Email: 'Correo electrónico',
      RegisterAsANewAccount: 'Regístrese como una nueva cuenta',
      LeaveUsYourRequirement: 'Déjanos tu requerimiento',
      Package: 'Paquete (Próximamente)',
      Bags: 'Bolsas (Próximamente)',
      CouponCode: 'Código promocional',
      Get: 'Conseguir',
      Tips1: 'Por favor, introduzca su correo electrónico válido',
      Tips2: 'Por favor introduzca la contraseña',
      Tips3: 'Por favor ingrese una contraseña de 6 a 20 caracteres',
      InputContent: 'contenido de entrada',
      Tips4: 'como volver',
      Tips5: 'Problemas de devoluciones y devoluciones',
      Tips6: 'Información de recibo incorrecta'
    },
    CategoryDetail: {
      InStock: 'En stock',
      Search: 'Buscar',
      ResultsFound: 'resultados encontrados',
      Fabric: 'Tela',
      Price: 'Precio',
      Products: 'productos',
      ClearAll: 'Limpiar todo',
      Submit: 'entregar',
      ShipFrom: 'Nave de'
    },
    pcDetail: {
      ShopSimilar: 'Comprar similares',
      Sales: 'Ventas',
      EndIn: 'terminar en',
      Over: 'encima',
      ShipTo: 'Envie a',
      ShipFrom: 'Nave de',
      China: 'China',
      ShipToMoreThan200CountriesAcrossTheGlobe: 'Realice envíos a más de 200 países de todo el mundo.',
      Germany: 'Alemania',
      ShipItemsOnlyWithinTheCountry: 'Envíe artículos solo dentro del país.',
      TipsOne: 'Por ejemplo: los productos de EE. UU. solo se admiten para envíos a EE. UU.',
      DeliveryTime: 'El tiempo de entrega',
      NoLogisticsChannel: 'Sin canal logístico',
      SoldOut: 'Agotado',
      Total: 'Total',
      Pieces: 'piezas',
      ResetQty: 'Restablecer cantidad',
      See20SimilarStyles: 'Ver más de 20 estilos similares',
      WeThinkYouLlLoveThese: 'Creemos que te encantarán estos',
      Sizing: 'Dimensionamiento',
      TrueToSize: 'Fiel al tamaño',
      MaterialComposition: 'Composición del material',
      TableData: 'tabla de datos',
      InchData: 'pulgadas de datos',
      Cost: 'Costo',
      PleaseSelect: 'Seleccione',
      AllVariants: 'Todas las variantes'
    }
  }
}
